const USER_EMAIL = 'userEmail'
const USER_PASSWORD_STEP = 'userPasswordStep'
const SET_PASSWORD = 'setPassword'
const USER_FIRST_AND_LAST = 'userFirstAndLast'
const COMPLETE = 'complete'
const COMPLETED_PASSWORD_LOGIN = 'completedPasswordLogin'
const CLIENT_NOT_FOUND = 'clientNotFound'

export const SIGN_UP_STEPS = {
  USER_EMAIL,
  USER_PASSWORD_STEP,
  SET_PASSWORD,
  USER_FIRST_AND_LAST,
  COMPLETE,
  COMPLETED_PASSWORD_LOGIN,
  CLIENT_NOT_FOUND
}

export const SIGN_UP_STEPS_ORDERED = [
  USER_EMAIL,
  USER_PASSWORD_STEP,
  SET_PASSWORD,
  USER_FIRST_AND_LAST,
  COMPLETE,
  COMPLETED_PASSWORD_LOGIN,
  CLIENT_NOT_FOUND
]
